/* eslint-disable */
// @ts-nocheck
// source: internal/bookkeeping.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.AccessMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.AccessStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.Assessment', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.AssessmentStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.StatusCase', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingStage', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ChampionPro', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ChampionPro.ChampionProCase', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.CycleCorrection', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.PlatformConnection', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.PlatformConnection.PlatformConnectionCase', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.PlatformConnectionIdCase', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.WorkItem', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.XeroAccount', null, global);
goog.exportSymbol('proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.XeroAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.XeroAccount.displayName = 'proto.worklayer.internal.bookkeeping.v1.XeroAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.displayName = 'proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.Assessment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.Assessment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.Assessment.displayName = 'proto.worklayer.internal.bookkeeping.v1.Assessment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.displayName = 'proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.displayName = 'proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.displayName = 'proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.displayName = 'proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.WorkItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.WorkItem.displayName = 'proto.worklayer.internal.bookkeeping.v1.WorkItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.displayName = 'proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.displayName = 'proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.displayName = 'proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.displayName = 'proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.PlatformConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.PlatformConnection.displayName = 'proto.worklayer.internal.bookkeeping.v1.PlatformConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.bookkeeping.v1.ChampionPro.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.ChampionPro, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.ChampionPro.displayName = 'proto.worklayer.internal.bookkeeping.v1.ChampionPro';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.displayName = 'proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.displayName = 'proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.bookkeeping.v1.CycleCorrection.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.bookkeeping.v1.CycleCorrection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.bookkeeping.v1.CycleCorrection.displayName = 'proto.worklayer.internal.bookkeeping.v1.CycleCorrection';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderBy: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest;
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string order_by = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tenantName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest;
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTenantName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tenant_name = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.getTenantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.setTenantName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    redirectUri: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest;
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRedirectUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string redirect_uri = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.getRedirectUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest.prototype.setRedirectUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse;
  return proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    connectedXeroAccountsList: jspb.Message.toObjectList(msg.getConnectedXeroAccountsList(),
    proto.worklayer.internal.bookkeeping.v1.XeroAccount.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse;
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.XeroAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinaryFromReader);
      msg.addConnectedXeroAccounts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectedXeroAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.XeroAccount.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated XeroAccount connected_xero_accounts = 1;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.XeroAccount>}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.getConnectedXeroAccountsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.XeroAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.XeroAccount, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.XeroAccount>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.setConnectedXeroAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.addConnectedXeroAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.bookkeeping.v1.XeroAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.clearConnectedXeroAccountsList = function() {
  return this.setConnectedXeroAccountsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest;
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.worklayer.internal.bookkeeping.v1.XeroAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse;
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.XeroAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.XeroAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional XeroAccount account = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.XeroAccount}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.getAccount = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.XeroAccount} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.XeroAccount, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.XeroAccount|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.XeroAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tenantName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    connectionId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.XeroAccount;
  return proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.XeroAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTenantName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tenant_name = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.getTenantName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.setTenantName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string connection_id = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.XeroAccount.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    realmId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest;
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealmId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRealmId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string realm_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.getRealmId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.setRealmId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workspace_id = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    realmId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    redirectUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest;
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealmId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRealmId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRedirectUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string realm_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.getRealmId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.setRealmId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string redirect_uri = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.getRedirectUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.setRedirectUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string workspace_id = 4;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse;
  return proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderBy: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest;
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string order_by = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    connectedQuickbooksAccountsList: jspb.Message.toObjectList(msg.getConnectedQuickbooksAccountsList(),
    proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse;
  return proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinaryFromReader);
      msg.addConnectedQuickbooksAccounts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectedQuickbooksAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated QuickBooksAccount connected_quickbooks_accounts = 1;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount>}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.getConnectedQuickbooksAccountsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.setConnectedQuickbooksAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.addConnectedQuickbooksAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.clearConnectedQuickbooksAccountsList = function() {
  return this.setConnectedQuickbooksAccountsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    realmId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest;
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealmId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRealmId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string realm_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.prototype.getRealmId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest.prototype.setRealmId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse;
  return proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional QuickBooksAccount account = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.getAccount = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    realmId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    connectionId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount;
  return proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealmId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRealmId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string realm_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.getRealmId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.setRealmId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string connection_id = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} returns this
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest;
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest;
  return proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.Assessment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberOfBankAccounts: jspb.Message.getFieldWithDefault(msg, 2, 0),
    avgMonthlyExpenses: (f = msg.getAvgMonthlyExpenses()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    cleanup: (f = msg.getCleanup()) && proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.toObject(includeInstance, f),
    comment: (f = msg.getComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    dateAssessed: (f = msg.getDateAssessed()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    assessedByUserId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.Assessment;
  return proto.worklayer.internal.bookkeeping.v1.Assessment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfBankAccounts(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAvgMonthlyExpenses(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.deserializeBinaryFromReader);
      msg.setCleanup(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAssessed(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssessedByUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.Assessment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumberOfBankAccounts();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvgMonthlyExpenses();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCleanup();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.serializeBinaryToWriter
    );
  }
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDateAssessed();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAssessedByUserId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup;
  return proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reason = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 number_of_bank_accounts = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getNumberOfBankAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setNumberOfBankAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal avg_monthly_expenses = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getAvgMonthlyExpenses = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
*/
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setAvgMonthlyExpenses = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.clearAvgMonthlyExpenses = function() {
  return this.setAvgMonthlyExpenses(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.hasAvgMonthlyExpenses = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Cleanup cleanup = 4;
 * @return {?proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getCleanup = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup, 4));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.Assessment.Cleanup|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
*/
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setCleanup = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.clearCleanup = function() {
  return this.setCleanup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.hasCleanup = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue comment = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
*/
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.hasComment = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp date_assessed = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getDateAssessed = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
*/
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setDateAssessed = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.clearDateAssessed = function() {
  return this.setDateAssessed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.hasDateAssessed = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string assessed_by_user_id = 7;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.getAssessedByUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.Assessment} returns this
 */
proto.worklayer.internal.bookkeeping.v1.Assessment.prototype.setAssessedByUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    connectionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection;
  return proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string connection_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    connectionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection;
  return proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string connection_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.prototype.getConnectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.prototype.setConnectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection;
  return proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string info = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.prototype.getInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.prototype.setInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.repeatedFields_ = [4,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accessStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cyclesList: jspb.Message.toObjectList(msg.getCyclesList(),
    proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.toObject, includeInstance),
    platformConnection: (f = msg.getPlatformConnection()) && proto.worklayer.internal.bookkeeping.v1.PlatformConnection.toObject(includeInstance, f),
    assessmentStatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assessmentReviewStatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    workItemsList: jspb.Message.toObjectList(msg.getWorkItemsList(),
    proto.worklayer.internal.bookkeeping.v1.WorkItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} */ (reader.readEnum());
      msg.setAccessStatus(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.deserializeBinaryFromReader);
      msg.addCycles(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.bookkeeping.v1.PlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.PlatformConnection.deserializeBinaryFromReader);
      msg.setPlatformConnection(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} */ (reader.readEnum());
      msg.setAssessmentStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} */ (reader.readEnum());
      msg.setAssessmentReviewStatus(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.bookkeeping.v1.WorkItem;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.WorkItem.deserializeBinaryFromReader);
      msg.addWorkItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAccessStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCyclesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.serializeBinaryToWriter
    );
  }
  f = message.getPlatformConnection();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.bookkeeping.v1.PlatformConnection.serializeBinaryToWriter
    );
  }
  f = message.getAssessmentStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAssessmentReviewStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getWorkItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.worklayer.internal.bookkeeping.v1.WorkItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BookkeepingStage stage = 2;
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getStage = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional AccessStatus access_status = 3;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AccessStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getAccessStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setAccessStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated BookkeepingCycle cycles = 4;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle>}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getCyclesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle, 4));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setCyclesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.addCycles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.clearCyclesList = function() {
  return this.setCyclesList([]);
};


/**
 * optional PlatformConnection platform_connection = 5;
 * @return {?proto.worklayer.internal.bookkeeping.v1.PlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getPlatformConnection = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.PlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.PlatformConnection, 5));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.PlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setPlatformConnection = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.clearPlatformConnection = function() {
  return this.setPlatformConnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.hasPlatformConnection = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AssessmentStatus assessment_status = 6;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getAssessmentStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setAssessmentStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional AssessmentReviewStatus assessment_review_status = 7;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getAssessmentReviewStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setAssessmentReviewStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated WorkItem work_items = 8;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItem>}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.getWorkItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.WorkItem, 8));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItem>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.setWorkItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.addWorkItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.worklayer.internal.bookkeeping.v1.WorkItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.prototype.clearWorkItemsList = function() {
  return this.setWorkItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.WorkItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    workItemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inventoryItemId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inventoryItemName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    completedCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    inventoryItemDescription: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.WorkItem;
  return proto.worklayer.internal.bookkeeping.v1.WorkItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedCount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryItemDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.WorkItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInventoryItemId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryItemName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCompletedCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getInventoryItemDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string work_item_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getWorkItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setWorkItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string inventory_item_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getInventoryItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setInventoryItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_item_name = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getInventoryItemName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setInventoryItemName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 quantity = 4;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 completed_count = 5;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getCompletedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setCompletedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string inventory_item_description = 6;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.getInventoryItemDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItem.prototype.setInventoryItemDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.TypeCase = {
  TYPE_NOT_SET: 0,
  BOOKKEEPING_PROGRESSION_INFO: 1,
  NOT_APPLICABLE: 2
};

/**
 * @return {proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.TypeCase}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bookkeepingProgressionInfo: (f = msg.getBookkeepingProgressionInfo()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.toObject(includeInstance, f),
    notApplicable: (f = msg.getNotApplicable()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse;
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.deserializeBinaryFromReader);
      msg.setBookkeepingProgressionInfo(value);
      break;
    case 2:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setNotApplicable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookkeepingProgressionInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.serializeBinaryToWriter
    );
  }
  f = message.getNotApplicable();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
};


/**
 * optional BookkeepingProgressionInfo bookkeeping_progression_info = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.getBookkeepingProgressionInfo = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.setBookkeepingProgressionInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.clearBookkeepingProgressionInfo = function() {
  return this.setBookkeepingProgressionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.hasBookkeepingProgressionInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty not_applicable = 2;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.getNotApplicable = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 2));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.setNotApplicable = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.clearNotApplicable = function() {
  return this.setNotApplicable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.prototype.hasNotApplicable = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_ = [[5,6,7]];

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.PlatformConnectionIdCase = {
  PLATFORM_CONNECTION_ID_NOT_SET: 0,
  QUICK_BOOKS: 5,
  XERO: 6,
  OTHER: 7
};

/**
 * @return {proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.PlatformConnectionIdCase}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.getPlatformConnectionIdCase = function() {
  return /** @type {proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.PlatformConnectionIdCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quickBooks: (f = msg.getQuickBooks()) && proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.toObject(includeInstance, f),
    xero: (f = msg.getXero()) && proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.toObject(includeInstance, f),
    other: (f = msg.getOther()) && proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest;
  return proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.deserializeBinaryFromReader);
      msg.setQuickBooks(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.deserializeBinaryFromReader);
      msg.setXero(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.deserializeBinaryFromReader);
      msg.setOther(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuickBooks();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection.serializeBinaryToWriter
    );
  }
  f = message.getXero();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection.serializeBinaryToWriter
    );
  }
  f = message.getOther();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional QuickBooksPlatformConnection quick_books = 5;
 * @return {?proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.getQuickBooks = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection, 5));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.setQuickBooks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.clearQuickBooks = function() {
  return this.setQuickBooks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.hasQuickBooks = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional XeroPlatformConnection xero = 6;
 * @return {?proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.getXero = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection, 6));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.setXero = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.clearXero = function() {
  return this.setXero(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.hasXero = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional OtherPlatformConnection other = 7;
 * @return {?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.getOther = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection, 7));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.setOther = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.clearOther = function() {
  return this.setOther(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest.prototype.hasOther = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse;
  return proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest;
  return proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse;
  return proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest;
  return proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse;
  return proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest;
  return proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse;
  return proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numberOfBankAccounts: jspb.Message.getFieldWithDefault(msg, 2, 0),
    avgMonthlyExpenses: (f = msg.getAvgMonthlyExpenses()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    cleanup: (f = msg.getCleanup()) && proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.toObject(includeInstance, f),
    comment: (f = msg.getComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest;
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfBankAccounts(value);
      break;
    case 3:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setAvgMonthlyExpenses(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.deserializeBinaryFromReader);
      msg.setCleanup(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumberOfBankAccounts();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAvgMonthlyExpenses();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getCleanup();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.serializeBinaryToWriter
    );
  }
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup;
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reason = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 number_of_bank_accounts = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.getNumberOfBankAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.setNumberOfBankAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional worklayer.shared.types.v1.Decimal avg_monthly_expenses = 3;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.getAvgMonthlyExpenses = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 3));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.setAvgMonthlyExpenses = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.clearAvgMonthlyExpenses = function() {
  return this.setAvgMonthlyExpenses(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.hasAvgMonthlyExpenses = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Cleanup cleanup = 4;
 * @return {?proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.getCleanup = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup, 4));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.Cleanup|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.setCleanup = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.clearCleanup = function() {
  return this.setCleanup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.hasCleanup = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue comment = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.getComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest.prototype.hasComment = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse;
  return proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest;
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse;
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest;
  return proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cycleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cycleNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse;
  return proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCycleNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCycleNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cycle_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 cycle_number = 3;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.getCycleNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.prototype.setCycleNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cycleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    completedItemsList: jspb.Message.toObjectList(msg.getCompletedItemsList(),
    proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest;
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.deserializeBinaryFromReader);
      msg.addCompletedItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompletedItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completedCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem;
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompletedCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 completed_count = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.getCompletedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem.prototype.setCompletedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cycle_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CompletedItem completed_items = 3;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem>}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.getCompletedItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.setCompletedItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.addCompletedItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.CompletedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest.prototype.clearCompletedItemsList = function() {
  return this.setCompletedItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse;
  return proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cycleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    correctedItemsList: jspb.Message.toObjectList(msg.getCorrectedItemsList(),
    proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest;
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCycleId(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.deserializeBinaryFromReader);
      msg.addCorrectedItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCycleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorrectedItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completedCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem;
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompletedCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 completed_count = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.getCompletedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem.prototype.setCompletedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cycle_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.getCycleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.setCycleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated CorrectedItem corrected_items = 3;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem>}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.getCorrectedItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.setCorrectedItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.addCorrectedItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.CorrectedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest.prototype.clearCorrectedItemsList = function() {
  return this.setCorrectedItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse;
  return proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    orderBy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    actionFilter: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest;
  return proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addWorkspaceIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter} */ (reader.readEnum());
      msg.setActionFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getActionFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * repeated string workspace_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};


/**
 * optional string order_by = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string page_token = 4;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string search_text = 5;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional BookkeepingActionFilter action_filter = 6;
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.getActionFilter = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest.prototype.setActionFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bookkeepingPendingActionsList: jspb.Message.toObjectList(msg.getBookkeepingPendingActionsList(),
    proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse;
  return proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.deserializeBinaryFromReader);
      msg.addBookkeepingPendingActions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookkeepingPendingActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated BookkeepingPendingAction bookkeeping_pending_actions = 1;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction>}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.getBookkeepingPendingActionsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.setBookkeepingPendingActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.addBookkeepingPendingActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.clearBookkeepingPendingActionsList = function() {
  return this.setBookkeepingPendingActionsList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest;
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addWorkspaceIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string workspace_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.getWorkspaceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.setWorkspaceIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.addWorkspaceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest.prototype.clearWorkspaceIdsList = function() {
  return this.setWorkspaceIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    confirmAccessTotal: jspb.Message.getFieldWithDefault(msg, 2, 0),
    assessmentReviewTotal: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse;
  return proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConfirmAccessTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssessmentReviewTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getConfirmAccessTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAssessmentReviewTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 total = 1;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 confirm_access_total = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.getConfirmAccessTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.setConfirmAccessTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 assessment_review_total = 3;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.getAssessmentReviewTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse} returns this
 */
proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.prototype.setAssessmentReviewTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.toObject = function(includeInstance, msg) {
  var f, obj = {
    userPublicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_public_id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.PlatformConnectionCase = {
  PLATFORM_CONNECTION_NOT_SET: 0,
  QUICK_BOOKS: 1,
  XERO: 2,
  NONE: 3,
  OTHER: 4
};

/**
 * @return {proto.worklayer.internal.bookkeeping.v1.PlatformConnection.PlatformConnectionCase}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.getPlatformConnectionCase = function() {
  return /** @type {proto.worklayer.internal.bookkeeping.v1.PlatformConnection.PlatformConnectionCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.PlatformConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    quickBooks: (f = msg.getQuickBooks()) && proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.toObject(includeInstance, f),
    xero: (f = msg.getXero()) && proto.worklayer.internal.bookkeeping.v1.XeroAccount.toObject(includeInstance, f),
    none: (f = msg.getNone()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    other: (f = msg.getOther()) && proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.PlatformConnection;
  return proto.worklayer.internal.bookkeeping.v1.PlatformConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.deserializeBinaryFromReader);
      msg.setQuickBooks(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.bookkeeping.v1.XeroAccount;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.XeroAccount.deserializeBinaryFromReader);
      msg.setXero(value);
      break;
    case 3:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setNone(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.deserializeBinaryFromReader);
      msg.setOther(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.PlatformConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuickBooks();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount.serializeBinaryToWriter
    );
  }
  f = message.getXero();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.bookkeeping.v1.XeroAccount.serializeBinaryToWriter
    );
  }
  f = message.getNone();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getOther();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection.serializeBinaryToWriter
    );
  }
};


/**
 * optional QuickBooksAccount quick_books = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.getQuickBooks = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.QuickBooksAccount|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.setQuickBooks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.clearQuickBooks = function() {
  return this.setQuickBooks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.hasQuickBooks = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional XeroAccount xero = 2;
 * @return {?proto.worklayer.internal.bookkeeping.v1.XeroAccount}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.getXero = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.XeroAccount} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.XeroAccount, 2));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.XeroAccount|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.setXero = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.clearXero = function() {
  return this.setXero(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.hasXero = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Empty none = 3;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.getNone = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 3));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.setNone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.clearNone = function() {
  return this.setNone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.hasNone = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OtherPlatformConnection other = 4;
 * @return {?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.getOther = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection, 4));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.OtherPlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.setOther = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.bookkeeping.v1.PlatformConnection.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.PlatformConnection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.clearOther = function() {
  return this.setOther(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.PlatformConnection.prototype.hasOther = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.ChampionProCase = {
  CHAMPION_PRO_NOT_SET: 0,
  MEMBER: 1,
  NONE: 2
};

/**
 * @return {proto.worklayer.internal.bookkeeping.v1.ChampionPro.ChampionProCase}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.getChampionProCase = function() {
  return /** @type {proto.worklayer.internal.bookkeeping.v1.ChampionPro.ChampionProCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.bookkeeping.v1.ChampionPro.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.ChampionPro.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.toObject = function(includeInstance, msg) {
  var f, obj = {
    member: (f = msg.getMember()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.toObject(includeInstance, f),
    none: (f = msg.getNone()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.ChampionPro;
  return proto.worklayer.internal.bookkeeping.v1.ChampionPro.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.deserializeBinaryFromReader);
      msg.setMember(value);
      break;
    case 2:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setNone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.ChampionPro.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMember();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.serializeBinaryToWriter
    );
  }
  f = message.getNone();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
};


/**
 * optional BookkeepingJobMember member = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.getMember = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.setMember = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.bookkeeping.v1.ChampionPro.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.clearMember = function() {
  return this.setMember(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.hasMember = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty none = 2;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.getNone = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 2));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} returns this
*/
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.setNone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.bookkeeping.v1.ChampionPro.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.ChampionPro} returns this
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.clearNone = function() {
  return this.setNone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.ChampionPro.prototype.hasNone = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    client: (f = msg.getClient()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.toObject(includeInstance, f),
    championPro: (f = msg.getChampionPro()) && proto.worklayer.internal.bookkeeping.v1.ChampionPro.toObject(includeInstance, f),
    jobName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    shortId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    accessMethod: jspb.Message.getFieldWithDefault(msg, 6, 0),
    stage: jspb.Message.getFieldWithDefault(msg, 7, 0),
    accessStatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    assessmentStatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateStageLastModified: (f = msg.getDateStageLastModified()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateAccessStatusLastModified: (f = msg.getDateAccessStatusLastModified()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    platformConnection: (f = msg.getPlatformConnection()) && proto.worklayer.internal.bookkeeping.v1.PlatformConnection.toObject(includeInstance, f),
    assessmentReviewStatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    datePendingSince: (f = msg.getDatePendingSince()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.ChampionPro;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.ChampionPro.deserializeBinaryFromReader);
      msg.setChampionPro(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortId(value);
      break;
    case 6:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessMethod} */ (reader.readEnum());
      msg.setAccessMethod(value);
      break;
    case 7:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 8:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} */ (reader.readEnum());
      msg.setAccessStatus(value);
      break;
    case 9:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} */ (reader.readEnum());
      msg.setAssessmentStatus(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateStageLastModified(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateAccessStatusLastModified(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 14:
      var value = new proto.worklayer.internal.bookkeeping.v1.PlatformConnection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.PlatformConnection.deserializeBinaryFromReader);
      msg.setPlatformConnection(value);
      break;
    case 15:
      var value = /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} */ (reader.readEnum());
      msg.setAssessmentReviewStatus(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDatePendingSince(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember.serializeBinaryToWriter
    );
  }
  f = message.getChampionPro();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.ChampionPro.serializeBinaryToWriter
    );
  }
  f = message.getJobName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShortId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccessMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAccessStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAssessmentStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateStageLastModified();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateAccessStatusLastModified();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPlatformConnection();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.worklayer.internal.bookkeeping.v1.PlatformConnection.serializeBinaryToWriter
    );
  }
  f = message.getAssessmentReviewStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getDatePendingSince();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BookkeepingJobMember client = 2;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getClient = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember, 2));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingJobMember|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasClient = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ChampionPro champion_pro = 3;
 * @return {?proto.worklayer.internal.bookkeeping.v1.ChampionPro}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getChampionPro = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.ChampionPro} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.ChampionPro, 3));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.ChampionPro|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setChampionPro = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearChampionPro = function() {
  return this.setChampionPro(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasChampionPro = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string job_name = 4;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getJobName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setJobName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string short_id = 5;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional AccessMethod access_method = 6;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AccessMethod}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getAccessMethod = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessMethod} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AccessMethod} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setAccessMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional BookkeepingStage stage = 7;
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getStage = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingStage} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional AccessStatus access_status = 8;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AccessStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getAccessStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AccessStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setAccessStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional AssessmentStatus assessment_status = 9;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getAssessmentStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AssessmentStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setAssessmentStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp date_stage_last_modified = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getDateStageLastModified = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setDateStageLastModified = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearDateStageLastModified = function() {
  return this.setDateStageLastModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasDateStageLastModified = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp date_access_status_last_modified = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getDateAccessStatusLastModified = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setDateAccessStatusLastModified = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearDateAccessStatusLastModified = function() {
  return this.setDateAccessStatusLastModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasDateAccessStatusLastModified = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string workspace_id = 13;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional PlatformConnection platform_connection = 14;
 * @return {?proto.worklayer.internal.bookkeeping.v1.PlatformConnection}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getPlatformConnection = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.PlatformConnection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.PlatformConnection, 14));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.PlatformConnection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setPlatformConnection = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearPlatformConnection = function() {
  return this.setPlatformConnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasPlatformConnection = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional AssessmentReviewStatus assessment_review_status = 15;
 * @return {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getAssessmentReviewStatus = function() {
  return /** @type {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setAssessmentReviewStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional google.protobuf.Timestamp date_pending_since = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.getDatePendingSince = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.setDatePendingSince = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.clearDatePendingSince = function() {
  return this.setDatePendingSince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingPendingAction.prototype.hasDatePendingSince = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    progressionInfo: (f = msg.getProgressionInfo()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.deserializeBinaryFromReader);
      msg.setProgressionInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgressionInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional BookkeepingProgressionInfo progression_info = 1;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.getProgressionInfo = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo, 1));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingProgressionInfo|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.setProgressionInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.clearProgressionInfo = function() {
  return this.setProgressionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingUpdatedRealtimeEvent.prototype.hasProgressionInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    number: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: (f = msg.getStatus()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.toObject(includeInstance, f),
    startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    correction: (f = msg.getCorrection()) && proto.worklayer.internal.bookkeeping.v1.CycleCorrection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumber(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.bookkeeping.v1.CycleCorrection;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.CycleCorrection.deserializeBinaryFromReader);
      msg.setCorrection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.serializeBinaryToWriter
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCorrection();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.bookkeeping.v1.CycleCorrection.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.StatusCase = {
  STATUS_NOT_SET: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  CANCELED: 3
};

/**
 * @return {proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.StatusCase}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.getStatusCase = function() {
  return /** @type {proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.StatusCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    inProgress: (f = msg.getInProgress()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    completed: (f = msg.getCompleted()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.toObject(includeInstance, f),
    canceled: (f = msg.getCanceled()) && proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setInProgress(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.deserializeBinaryFromReader);
      msg.setCompleted(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.deserializeBinaryFromReader);
      msg.setCanceled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInProgress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getCompleted();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.serializeBinaryToWriter
    );
  }
  f = message.getCanceled();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.toObject, includeInstance),
    completedAt: (f = msg.getCompletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    completedById: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCompletedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletedById(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.serializeBinaryToWriter
    );
  }
  f = message.getCompletedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCompletedById();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated WorkItemCompletion items = 1;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional google.protobuf.Timestamp completed_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.getCompletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.setCompletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.clearCompletedAt = function() {
  return this.setCompletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.hasCompletedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string completed_by_id = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.getCompletedById = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed.prototype.setCompletedById = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.toObject = function(includeInstance, msg) {
  var f, obj = {
    canceledAt: (f = msg.getCanceledAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled;
  return proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCanceledAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanceledAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp canceled_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.getCanceledAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.setCanceledAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.clearCanceledAt = function() {
  return this.setCanceledAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled.prototype.hasCanceledAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty in_progress = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.getInProgress = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.setInProgress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.clearInProgress = function() {
  return this.setInProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.hasInProgress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Completed completed = 2;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.getCompleted = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed, 2));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Completed|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.setCompleted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.clearCompleted = function() {
  return this.setCompleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.hasCompleted = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Canceled canceled = 3;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.getCanceled = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled, 3));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.Canceled|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.setCanceled = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.clearCanceled = function() {
  return this.setCanceled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus.prototype.hasCanceled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 number = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CycleStatus status = 3;
 * @return {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.getStatus = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus, 3));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.CycleStatus|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp started_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CycleCorrection correction = 5;
 * @return {?proto.worklayer.internal.bookkeeping.v1.CycleCorrection}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.getCorrection = function() {
  return /** @type{?proto.worklayer.internal.bookkeeping.v1.CycleCorrection} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.bookkeeping.v1.CycleCorrection, 5));
};


/**
 * @param {?proto.worklayer.internal.bookkeeping.v1.CycleCorrection|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
*/
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.setCorrection = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle} returns this
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.clearCorrection = function() {
  return this.setCorrection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingCycle.prototype.hasCorrection = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completedCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion;
  return proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompletedCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 completed_count = 2;
 * @return {number}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.getCompletedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.setCompletedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion} returns this
 */
proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.bookkeeping.v1.CycleCorrection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.toObject = function(includeInstance, msg) {
  var f, obj = {
    correctedAt: (f = msg.getCorrectedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    correctedById: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.bookkeeping.v1.CycleCorrection;
  return proto.worklayer.internal.bookkeeping.v1.CycleCorrection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCorrectedAt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrectedById(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion;
      reader.readMessage(value,proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.bookkeeping.v1.CycleCorrection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrectedAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCorrectedById();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp corrected_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.getCorrectedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.setCorrectedAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.clearCorrectedAt = function() {
  return this.setCorrectedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.hasCorrectedAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string corrected_by_id = 2;
 * @return {string}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.getCorrectedById = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.setCorrectedById = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated WorkItemCompletion items = 3;
 * @return {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion, 3));
};


/**
 * @param {!Array<!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion>} value
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} returns this
*/
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion}
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.worklayer.internal.bookkeeping.v1.WorkItemCompletion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.bookkeeping.v1.CycleCorrection} returns this
 */
proto.worklayer.internal.bookkeeping.v1.CycleCorrection.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingStage = {
  BOOKKEEPING_STAGE_UNSPECIFIED: 0,
  PENDING: 1,
  PROVISIONING_ACCESS: 2,
  ASSESSING_BOOKS: 3,
  READY_TO_START: 4,
  CYCLE_IN_PROGRESS: 5,
  COMPLETED: 6,
  SCOPE_EXTENSION_REQUESTED: 7
};

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.AccessStatus = {
  ACCESS_STATUS_UNSPECIFIED: 0,
  NOT_REQUESTED: 1,
  MANAGED_ACCESS_CLIENT_CONNECTION_REQUESTED: 2,
  MANAGED_ACCESS_CLIENT_CONFIRMATION_REQUESTED: 3,
  MANAGED_ACCESS_ADMIN_CONFIRMATION_REQUESTED: 4,
  MANAGED_ACCESS_CONFIRMED: 5,
  UNMANAGED_ACCESS_PROVIDER_CONFIRMATION_REQUESTED: 6,
  UNMANAGED_ACCESS_CONFIRMED: 7
};

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.AccessMethod = {
  ACCESS_METHOD_UNSPECIFIED: 0,
  MANAGED: 1,
  UNMANAGED: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.AssessmentStatus = {
  ASSESSMENT_STATUS_UNSPECIFIED: 0,
  NO_ASSESSMENT: 1,
  REQUESTED: 2,
  SUBMITTED: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.AssessmentReviewStatus = {
  ASSESSMENT_REVIEW_STATUS_UNSPECIFIED: 0,
  REVIEW_NOT_APPLICABLE: 1,
  REVIEW_REQUESTED: 2,
  REVIEWED: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingActionFilter = {
  ALL: 0,
  CONFIRM_ACCESS: 1,
  ASSESSMENT_REVIEW: 2
};

goog.object.extend(exports, proto.worklayer.internal.bookkeeping.v1);
